import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import {
    LoanPurposeApiEndpoints,
    LoanPurposeResponse,
    LoanPurposeState,
    UpdateLoanPurposeRequest,
} from './loanPurposeTypes';

import { initialStateLoanPurpose as initialState } from './loanPurposeDefaultValue';
import { ApiStatus } from '../../types';
const loanPurposeSlice = createSlice({
    name: 'loanPurpose',
    initialState,
    reducers: {
        updateLoanPurposeEndpoints: (state, action: PayloadAction<LoanPurposeApiEndpoints>) => {
            state.apiEndpoints = action.payload;
        },        
        loanPurposeSubmit: (state) => state,

        getLoanPurposes(state) {
            state.getLoanPurposeApiStatus = ApiStatus.Pending;
        },
        getLoanPurposesFulfilled(state, action: PayloadAction<LoanPurposeResponse>) {
            state.getLoanPurposeApiStatus = ApiStatus.Fulfilled;

            const {
                content,
                loanPurposeData,
            } = action.payload;

            state.content = content;
            state.loanPurposeData = loanPurposeData;
        },
        getLoanPurposesRejected(state) {
            state.getLoanPurposeApiStatus = ApiStatus.Rejected;
        },
        updateSelectedLoanPurpose(state, action: PayloadAction<number[]>) {
            state.selectedLoanPurposeIds = action.payload;
        },        
        updateLoanPurpose(state, action: PayloadAction<UpdateLoanPurposeRequest>) {
            state.updateLoanPurposeApiStatus = ApiStatus.Pending;
            state.updateLoanPurposeRequest = action.payload;
        },
        updateLoanPurposesFulfilled(state) {
            state.updateLoanPurposeApiStatus = ApiStatus.Fulfilled;
        },
        updateLoanPurposesRejected(state) {
            state.updateLoanPurposeApiStatus = ApiStatus.Rejected;
        },
        resetLoanPurposesStatus(state) {
            state.getLoanPurposeApiStatus = ApiStatus.Idle;
            state.updateLoanPurposeApiStatus = ApiStatus.Idle;
        },
    },
});

export const {
    updateLoanPurposeEndpoints,
    loanPurposeSubmit,
    getLoanPurposes,
    getLoanPurposesFulfilled,
    getLoanPurposesRejected,
    updateSelectedLoanPurpose,
    updateLoanPurpose,
    updateLoanPurposesFulfilled,
    updateLoanPurposesRejected,
    resetLoanPurposesStatus,
} = loanPurposeSlice.actions;

export const loanPurposeReducer: Reducer<LoanPurposeState, AnyAction> = loanPurposeSlice.reducer;
